import { i18n } from "../../i18n";
import { GpxImportError, GpxImportErrorCode } from "./gpxImportError";

/**
 * Resolve any error thrown by an import flow into a localized, user-facing message
 * that states the specific reason. Unknown errors fall back to a safe generic string.
 */
export function gpxImportErrorMessage(error: unknown): string {
  const t = i18n.global.t;

  if (error instanceof GpxImportError) {
    return t(`gpxImport.errors.${error.code}`);
  }

  // MultiRouteError from ImportFileHelper predates this taxonomy; map it here so the
  // message stays consistent without changing that class's public shape.
  if (error instanceof Error && error.name === "MultiRouteError") {
    return t(`gpxImport.errors.${GpxImportErrorCode.MultipleRoutes}`);
  }

  return t(`gpxImport.errors.${GpxImportErrorCode.Generic}`);
}
